type SectionHeadingProps = {
  children: string
  subtitle?: string
  align?: 'left' | 'center'
  className?: string
}

export default function SectionHeading({
  children,
  subtitle,
  align = 'left',
  className = '',
}: SectionHeadingProps) {
  const alignClass = align === 'center' ? 'text-center items-center' : 'text-left items-start'

  return (
    <div className={`flex flex-col gap-1.5 ${alignClass} ${className}`}>
      <h2 className="font-host text-2xl font-semibold leading-[1.5] tracking-[-0.022em] text-black">
        {children}
      </h2>
      {subtitle && (
        <p className="font-host text-base font-normal leading-[1.5] tracking-[-0.022em] text-text-muted">
          {subtitle}
        </p>
      )}
    </div>
  )
}

type SectionBadgeProps = {
  children: string
  className?: string
}

export function SectionBadge({ children, className = '' }: SectionBadgeProps) {
  return (
    <div
      className={`inline-flex h-[27px] items-center justify-center rounded-xl border border-[#C8C8C8] bg-surface-gray px-2.5 ${className}`}
    >
      <span className="font-host text-xs font-medium leading-[1.75] text-brand-orange">
        {children}
      </span>
    </div>
  )
}
